module.exports = __webpack_public_path__ + "static/media/animal-penguin.953580f5.png";